import * as React from "react"

export interface UIConfig {
  isRTL: boolean
}

export const UIConfigContext = React.createContext<UIConfig | undefined>(undefined)

export interface UIConfigProviderProps {
  value: UIConfig
  children: React.ReactNode
}

export const UIConfigProvider: React.FC<UIConfigProviderProps> = ({ value, children }) => {
  return (
    <UIConfigContext.Provider value={value}>
      {children}
    </UIConfigContext.Provider>
  )
}

export function useUIConfig(): UIConfig {
  const context = React.useContext(UIConfigContext)
  if (!context) {
    throw new Error("useUIConfig must be used within a UIConfigProvider")
  }
  return context
}

